import {BUSINESS_COACH, BUSINESS_LEADER, COACH} from '/enum/competency.enum';

export const getIsBusinessLeader = (currentUserCompetency: string) => {
  const isBusinessLeader = currentUserCompetency === BUSINESS_LEADER;
  const isBusinessLeaderOrBusinessCoach =
    isBusinessLeader || currentUserCompetency === BUSINESS_COACH;

  return {
    isBusinessLeader,
    isBusinessLeaderOrBusinessCoach,
  };
};

export const getIsCoach = (currentUserCompetency: string) =>
  currentUserCompetency === COACH;
